/*
	Renders a basic table of Assets with their name and id.
*/

import React from "react";
import PropTypes from "prop-types";
import { TextOverflow } from "utils/common";

import "./AssetsTable.css";

export default function AssetsTable(props){
	const { assets, className } = props;
	const rows = assets.map((asset) => {
		const { name, id } = asset || {};
		let nameContent = <TextOverflow value={name} />;

		return (
			<tr key={id}>
				<td className="asset-name-column name-col">
					{nameContent}
				</td>
				<td className="asset-id-column id-col">{id}</td>
			</tr>
		);
	});

	return (
		<table className={`assets-table basic-table ${className}`}>
			<thead>
				<tr>
					<th className="asset-name-column name-col">Asset Name</th>
					<th className="asset-id-column id-col">ID</th>
				</tr>
			</thead>
			<tbody>
				{rows}
			</tbody>
		</table>
	);
}

AssetsTable.displayName = "AssetsTable";

AssetsTable.propTypes = {
	assets: PropTypes.arrayOf(PropTypes.shape({
		id: PropTypes.oneOfType([
			PropTypes.string,
			PropTypes.number,
		]),
		name: PropTypes.string,
	})),
	className: PropTypes.string,
};

AssetsTable.defaultProps = {
	assets: [],
	className: "",
};
